export default {
  home: {
    sections: {
      trendingToday: "Em alta hoje",
      offers: "Ofertas",
      partners: "Parceiros",
      cheatsheets: "Guias rápidos",
      predictionMarkets: "Mercados de previsão",
      advancedTools: "Ferramentas avançadas",
      parlays: "Parlays",
      upcomingGames: "Próximos jogos",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Escolhas diárias",
        BOOST: "Boosts",
        SPORTSBOOK_SIGNUP: "Casa de apostas",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Previsão",
        SWEEPSTAKES_SIGNUP: "Sorteios",
        CASINO_SIGNUP: "Cassino",
        PARTNER: "Parceiros",
      },
    },
    offseason: {
      eyebrow: "Entressafra",
      body: "Nos vemos em breve na nova temporada!",
    },
    seasonChampion: {
      description: "{{team}} são os {{championship}}.",
      descriptionWithArticle: "Os {{team}} são os {{championship}}.",
      descriptions: {
        default: "Campeões da {{league}}",
        superbowl: "Campeões do Super Bowl",
        stanleyCup: "Campeões da Stanley Cup",
        premierLeague: "Campeões da Premier League",
        worldSeries: "Campeões da World Series",
        european: "Campeões europeus",
        europaLeague: "Campeões da Europa League",
        ncaaBasketball: "Campeões de basquete da NCAA",
        ncaaFootball: "Campeões de futebol americano da NCAA",
      },
    },
    noGamesToday: "Não há jogos hoje na {{league}}.",
    currentlyInOffseason: "Atualmente na offseason.",
    featured: {
      gameOfDay: "Jogo do dia",
      gameOfWeek: "Jogo da semana",
      parlayTrends: "Tendências de parlay",
      cheatsheets: "Guias rápidos",
      unlockRewardTitle: "Desbloqueie sua recompensa",
      unlockRewardSubtitle: "Resgate o acesso premium para ver mais.",
      unlockRewardBody: "Tenha acesso a mais tendências, ferramentas e insights.",
    },
    cards: {
      placeItOn: "Aposte em",
      advancedToolsCta: "Entrar no Linemate+",
      premiumBlurb: "Desbloqueie a experiência completa. Aprofunde-se em cada tendência.",
    },
    empty: {
      trend: "Nenhuma tendência disponível. Volte mais tarde.",
      cheatsheet: "Nenhum guia rápido disponível. Volte mais tarde.",
      offer: "Nenhuma oferta disponível. Volte mais tarde.",
    },
    cheatsheets: {
      recentForm: "Forma recente",
      versusOpponent: "Contra o adversário",
      alternateLines: "Linhas alternativas",
      firstQuarter: "1º quarto",
      firstHalf: "1º tempo",
      homeAwayGames: "Jogos casa/fora",
      teamForm: "Forma da equipe",
      undersOnly: "Apenas under",
    },
    tools: {
      props: "Props",
      markets: "Mercados",
      cheatsheets: "Guias rápidos",
      generateParlay: "Criador de acumuladas",
      lineups: "Escalações",
      injuries: "Lesões",
      rank: "Ranking",
      weather: "Clima",
      pitchers: "Arremessadores",
      stats: "Estatísticas",
      standings: "Classificação",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Use a forma recente, o histórico de confrontos ou o desempenho em casa e fora.",
        recentFormDescription: "Desempenho nos últimos 20 jogos",
        versusOpponentDescription: "Últimos 20 jogos contra este adversário",
        homeAwaySplitsDescription: "Últimos 20 jogos em casa ou fora",
      },
      legs: {
        title: "Quantas seleções você quer?",
        subtitle: "Escolha o tamanho da acumulada que você quer gerar",
        label: "{{count}} seleções",
      },
      participants: {
        title: "Quem deve ser incluído?",
        subtitle: "Escolha quais equipes ou jogadores você quer na sua acumulada",
        searchPlayer: "Buscar um jogador",
        searchTeam: "Buscar uma equipe",
        allPlayers: "Todos os jogadores",
        allTeams: "Todas as equipes",
      },
      result: {name: "Acumulada", title: "Sua acumulada"},
      empty: {
        title: "Nenhuma acumulada encontrada",
        subtitle: "Tente alterar suas seleções para gerar uma acumulada.",
      },
      actions: {goHome: "Voltar ao início", share: "Compartilhar acumulada"},
      loader: {
        ready: "Acumulada pronta",
        accessibilityLabel: "Gerando sua acumulada",
        values: {
          legs: "{{count}} seleções...",
          allGames: "Todos os jogos...",
          selectedGames: "{{count}} jogos...",
          allPlayers: "Todos os jogadores...",
          allTeams: "Todas as equipes...",
          selectedParticipants: "{{count}} participantes...",
          selectedBetTypes: "{{count}} tipos de aposta...",
          selectedSportsbooks: "{{count}} casas de aposta...",
          building: "Criando sua acumulada...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Hub de mercados de previsão",
      values: {
        points: "{{count}} pts",
        trades: "{{count}} negociações",
      },
      analysis: {
        title: "Análise de mercado",
        allExchanges: "Todas as bolsas",
        perExchange: "Por bolsa",
        chips: {
          all: "Tudo",
          oneDay: "1 dia",
          oneWeek: "1 semana",
        },
        rows: {
          volume: "Volume",
          movement: "Movimento",
          marketSplit: "Divisão do mercado",
          largestTrade: "Maior negociação",
          activity: "Atividade",
        },
      },
      cards: {
        mostVolume: {
          title: "Maior volume",
          description: "Mercados com mais dinheiro negociado",
        },
        largestTrades: {
          title: "Maiores negociações",
          description: "Mercados com as maiores negociações individuais",
        },
        biggestMovers: {
          title: "Maiores movimentos",
          description: "Mercados com as maiores mudanças de probabilidade",
        },
        marketsSplit: {
          title: "Divisão dos mercados",
          description: "Mercados com as maiores diferenças entre plataformas",
        },
        mostActivity: {
          title: "Maior atividade",
          description: "Mercados com o maior número de negociações",
        },
      },
      previews: {
        superBowlWinner: "Vencedor do Super Bowl",
        nbaChampions: "Campeões da NBA",
        worldSeriesWinner: "Vencedor da World Series",
        easternConference: "Conferência Leste",
        westernConference: "Conferência Oeste",
        nfcWinner: "Vencedor da NFC",
        afcChampions: "Campeões da AFC",
        alPennant: "Flâmula da AL",
        stanleyCup: "Stanley Cup",
        afcEast: "AFC East",
        afcNorth: "AFC North",
        nfcNorth: "NFC North",
        nfcWest: "NFC West",
        nlCentral: "NL Central",
        nlWest: "NL West",
        premierLeague: "Premier League",
        divisionWinner: "Vencedor da divisão",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} contra",
      vsOpponent: "vs {{opponent}}",
    },
    sponsoredBy: "Patrocinado por {{operator}}",
  },
};
